export const DeclarationEnumTypeLabel: Record<string, string> = {
    NOT_FILED: 'terms.declaration.type.not_filled',
    PAYABLE: 'terms.declaration.type.payable',
    DEDUCTION: 'terms.declaration.type.deduction',
    ZERO: 'terms.declaration.type.zero',
};

export const DeclarationGapTypeLabel: Record<string, string> = {
    DECLARATION_NOT_FILED: 'terms.declaration.gap_type.dec_not_filled',
    NDS_NOT_PAID: 'terms.declaration.gap_type.tax_not_paid',
    INVOICE_DIFFER: 'terms.declaration.gap_type.invoice_differ',
};

export const TaxpayerTransitOrGapLabel: Record<string, string> = {
    TRANSIT_COMPANY: 'terms.taxpayer.transit_company',
    GAP_SOURCE: 'terms.taxpayer.gap_source',
    OTHER: 'terms.taxpayer.other',
};

export const TaxpayerPayStatusLabel: Record<string, string> = {
    PAID: 'page_relations.pay_status.paid',
    PARTIALLY_PAID: 'page_relations.pay_status.partially_paid',
    NOT_PAID: 'page_relations.pay_status.not_paid',
};
